import { render, staticRenderFns } from "./AllDiscounts.vue?vue&type=template&id=098cf582&"
import script from "./AllDiscounts.vue?vue&type=script&lang=js&"
export * from "./AllDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports